import { computed } from 'vue';
import { defineStore } from 'pinia';
import { useDatapeopleAnywhereEditor } from '@/stores/document/datapeopleAnywhereEditor';
import { useRoute } from 'vue-router';

export const useSideBySideView = defineStore('sideBySideView', () => {
  const sideBySideView = computed(() => {
    const dpaStore = useDatapeopleAnywhereEditor();
    if (dpaStore.isDatapeopleAnywhereEditor && dpaStore.similarJobId) {
      return 'datapeopleAnywhereSimilarJob';
    }
    if (dpaStore.isDatapeopleAnywhereEditor && dpaStore.showDatapeopleAnywhereSideBySide) {
      return 'datapeopleAnywhereApplyTemplate';
    }

    const match = Object.entries(useRoute()?.query || {}).find(([k, v]) => ((k === 'sideRevision' && v !== undefined)
      || (k === 'similarJobs' && v !== undefined)));
    return match ? match[0] : false;
  });

  return {
    sideBySideView,
  };
});
